export function isCurrentYear(date: Date | string) {
  if (typeof date === 'string') date = new Date(date)

  const today = new Date()
  return date.getFullYear() === today.getFullYear()
}
